'use strict';

import { ConeGeometry, CylinderGeometry } from 'three';
import { ObjectCore } from './ObjectCore';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils';


export class Arrow extends ObjectCore{

  constructor (data,textureLoader) {

    const cone = new ConeGeometry(0.2,1,12);
    cone.center();
    cone.translate(0,1,0);
    const cylinder = new CylinderGeometry(0.1,0.1,1,12);
    const merge = mergeGeometries([cone,cylinder]);

    super(data,merge,textureLoader);

    this.objectType = 'Arrow';
  }

}
